<template>
  <v-data-table
    v-bind="dataTableAttrs"
    :headers="headersShown"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
    :show-select="false"
  >
    <template v-slot:top>
      <rs-table-title-bar
        class="mt-6"
        v-if="$refs.headSearch"
        title=""
        icon=""
        @clear-filters="$refs.headSearch.reset"
        @reload="loadList"
        :search.sync="search.query"
        :add-route="allowAdd ? '#' : null"
        @click:add="handleAddClick"
        hide-edit
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.prepend="{ headers }">
      <rs-table-head-search
        :headers="headers"
        :search.sync="search"
        ref="headSearch"
      />
      <CustomerPaymentForm
        ref="customerPaymentForm"
        :customer-id="customerId"
        :invoice-id="invoiceId"
        @saved="loadList"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:body.append="{ headers }">
      <rs-table-foot-totals
        :headers="headers"
        :totals="footTotals"
        v-if="list.length > 0"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <a
        class="btn btn-icon btn-sm btn-clean"
        href="#"
        @click.prevent="handleEditClick(item)"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </a>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.invoice_payment_amount="{ value, item }">
      <template v-if="item.payment_amount !== value">
        <span class="text-muted" title="Toplam ödeme tutarı">
          (<rs-table-cell-number price :value="item.payment_amount" />)
        </span>
      </template>
      <rs-table-cell-number price :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.success_at="{ value }">
      <rs-table-cell-date show-time :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <rs-table-button-delete
        @deleted="handleDeleteClick(item)"
        confirmed
        :loading="isLoading"
      />
    </template>

    <!-- eslint-disable-next-line -->
    <!-- <template v-slot:item.removed_at="{ value, item }">
      <rs-table-cell-date show-time :value="value" v-if="value" />
      <rs-table-button-delete
        v-else
        @deleted="handleDeleteConfirmed(item)"
        :loading="isLoading"
        confirmed
        label="Kaldır"
      />
    </template> -->
  </v-data-table>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";
import { hasDataTable } from "@/view/mixins";
import CustomerPaymentForm from "./CustomerPaymentForm.vue";

export default {
  name: "AdminCustomerInvoicePaymentList",
  components: {
    CustomerPaymentForm,
  },
  mixins: [hasDataTable],
  props: {
    customerId: {
      type: Number,
      required: false,
    },
    invoiceId: {
      type: Number,
      required: false,
    },
    paymentId: {
      type: Number,
      required: false,
    },
    allowAdd: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    customerId() {
      this.loadList();
    },
    invoiceId() {
      this.loadList();
    },
    search: {
      handler: debounce(function () {
        this.loadList();
      }),
      deep: true,
    },
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
  },
  data() {
    return {
      options: {
        sortBy: ["success_at"],
        sortDesc: [true],
      },
      search: {
        is_active: true,
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: "Tarih",
          value: "success_at",
          searchable: "date",
        },
        {
          text: "Açıklama",
          value: "description",
          searchable: "text",
        },
        {
          text: "Ödenen Tutar",
          value: "invoice_payment_amount",
          searchable: "number",
          align: "end",
        },
        // {
        //   text: null,
        //   value: "actions",
        //   searchable: false,
        //   sortable: false,
        //   align: "right",
        // },
      ],
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.list = [];

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      if (this.invoiceId) {
        params.customer_invoice_id = this.invoiceId;
      }

      if (this.customerId) {
        params.customer_id = this.customerId;
      }

      if (this.paymentId) {
        params.customer_payment_id = this.paymentId;
      }

      return this.$api
        .query("api-super-admin/customer-invoice-payments", {
          params,
        })
        .then((response) => {
          this.loadListFromResponse(response);
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
    handleAddClick() {
      this.$refs.customerPaymentForm.show();
    },
    handleEditClick(item) {
      this.$refs.customerPaymentForm.show(item.id);
    },
    // handleDeleteClick(item) {
    //   if (this.isLoading) {
    //     return false;
    //   }

    //   this.isLoading = true;

    //   return this.$api
    //     .delete(`api-super-admin/customer-invoices/${item.id}`)
    //     .then(() => {
    //       this.$toast.success(this.$t("toasts.item_deleted"));
    //     })
    //     .catch((error) => {
    //       this.handleError(error);
    //     })
    //     .finally(() => {
    //       this.isLoading = false;
    //     })
    //     .then(() => {
    //       this.loadList();
    //     });
    // },
  },
  mounted() {
    this.$nextTick(() => {
      this.loadList();
    });
  },
};
</script>
